import { render, staticRenderFns } from "./TherapistDashModalRemoveDay.vue?vue&type=template&id=9e6b7d68&scoped=true"
import script from "./TherapistDashModalRemoveDay.vue?vue&type=script&lang=js"
export * from "./TherapistDashModalRemoveDay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6b7d68",
  null
  
)

export default component.exports